import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box, Button, Paper, Stack, Typography, Chip, IconButton, Tooltip,
  Table, TableBody, TableCell, TableHead, TableRow,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";
import LinkIcon from "@mui/icons-material/Link";
import Swal from "sweetalert2";
import { listarEdicoes, excluirEdicao, linkInscricao } from "../../services/edicaoService";

export default function EdicaoList() {
  const navigate = useNavigate();
  const [edicoes, setEdicoes] = useState([]);

  const carregar = async () => {
    try {
      const { data } = await listarEdicoes();
      setEdicoes(data);
    } catch (e) {
      Swal.fire("Erro", e?.response?.data || e.message, "error");
    }
  };
  useEffect(() => { carregar(); }, []);

  const copiarLink = async (token) => {
    const url = linkInscricao(token);
    try { await navigator.clipboard.writeText(url); } catch (_) {}
    Swal.fire({ title: "Link de inscrição", html: `<code style="word-break:break-all">${url}</code><br/><br/>Copiado para a área de transferência.`, icon: "success" });
  };

  const inativar = async (id) => {
    const r = await Swal.fire({ title: "Inativar edição?", icon: "warning", showCancelButton: true, confirmButtonText: "Inativar", cancelButtonText: "Cancelar" });
    if (!r.isConfirmed) return;
    await excluirEdicao(id);
    carregar();
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5">Edições / Editais</Typography>
        <Button variant="contained" onClick={() => navigate("/edicoes/nova")}>Nova edição</Button>
      </Stack>

      <Paper>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell align="center">Ano</TableCell>
              <TableCell>Formulário</TableCell>
              <TableCell>Período</TableCell>
              <TableCell align="center">Fichas</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="center">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {edicoes.map((e) => (
              <TableRow key={e.Id} hover>
                <TableCell>{e.Nome}</TableCell>
                <TableCell align="center">{e.Ano}</TableCell>
                <TableCell>{e.Formulario}</TableCell>
                <TableCell>
                  {e.DataInicio ? new Date(e.DataInicio).toLocaleDateString("pt-BR") : "—"} a{" "}
                  {e.DataFim ? new Date(e.DataFim).toLocaleDateString("pt-BR") : "—"}
                </TableCell>
                <TableCell align="center">{e.QtdFichas}</TableCell>
                <TableCell align="center">
                  <Chip size="small" label={e.Ativo ? "Ativa" : "Inativa"} color={e.Ativo ? "success" : "default"} />
                </TableCell>
                <TableCell align="center">
                  <Tooltip title="Copiar link de inscrição">
                    <IconButton size="small" color="primary" onClick={() => copiarLink(e.TokenPublico)}>
                      <LinkIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <IconButton size="small" onClick={() => navigate(`/edicoes/${e.Id}`)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                  {e.Ativo && (
                    <IconButton size="small" color="error" onClick={() => inativar(e.Id)}>
                      <BlockIcon fontSize="small" />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {edicoes.length === 0 && (
              <TableRow><TableCell colSpan={7} align="center">Nenhuma edição.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
